{
    "DataTable_AreYouSure": "Tem certeza de que deseja excluir o seguinte? \n \n **{}**",
    "NAME": "LanguageDataTable",
    "DataTable_RowsPerPage": "Linhas por página",
    "DataTable_Of": "{}-{} of {}",
    "DataTable_Next": "Próxima página",
    "DataTable_Previous": "Página anterior"
}